export const UPDATE_DOWNTIME_STATE = "UPDATE_DOWNTIME_STATE"
export const DOWNTIME_CREATED = "DOWNTIME_CREATED"
export const DOWNTIME_UPDATED = "DOWNTIME_UPDATED"
